/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Subdomain } from "./data-contracts";

/**
 * No description
 * @tags subdomains
 * @name GetSubdomain
 * @summary Get a subdomain
 * @request GET:/subdomains/{subdomain}
 * @secure
 */

// @ts-ignore
export const getSubdomain: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * The subdomain, for example "my-company" in "my-company.gitbook.io"
     * @minLength 3
     * @maxLength 32
     * @pattern ^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$
     */
    subdomain: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Subdomain;
  ResponseStatusCode: 200;
} = {
  route: "/subdomains/{subdomain}",
  method: "get",
  streaming: false,
  tags: ["subdomains"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
